import type { CommonThunk } from 'c-types';
import { callApi, errorMessageFromResponse, normaliseDataThunks } from 'c-data-layer';
import apiClient from 'c-data/apiClient';
import { commonSchemas } from 'c-data';
import { NetworkRequestState } from 'c-data-layer';
import { campaignReportingActions } from 'c-admin/Slices/CampaignReporting/CampaignReporting-slice';
import { getAttachingConfigById } from './CampaignReporting-selectors';

export default {};

/**
 * Assign a saved configuration to users / agencies / buyers / clients / owners.
 * An omitted key leaves that relation untouched; an empty array clears it.
 */
export const attachCampaignReporting =
    (
        configId: number,
        options: {
            users?: number[];
            agencies?: number[];
            buyers?: number[];
            clients?: number[];
            owners?: number[];
        },
    ): CommonThunk =>
    async (dispatch, getState) => {
        if (getAttachingConfigById(getState())(configId).state === NetworkRequestState.InProgress) {
            return;
        }
        dispatch(campaignReportingActions.startAttachingConfigById(configId));

        const [error, data] = await dispatch(
            callApi(apiClient.Entities.CampaignReporting.attach({ configId, ...options }).request),
        );

        if (!error) {
            dispatch(
                normaliseDataThunks.updateWithNormalisedData(
                    commonSchemas.CampaignReporting,
                    data.data,
                ),
            );
            dispatch(campaignReportingActions.finishedAttachingConfigById(configId));
            return;
        }
        dispatch(
            campaignReportingActions.failedAttachingConfigById({
                id: configId,
                error: errorMessageFromResponse(error),
            }),
        );
    };
